import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms';
/**
 * コード入力検索フィールド
 *【ラベル内容:labelContent:string】
 *【内容:content:{value: string, value2?: string, label: string}】
 *【プレースホルダ:placeholder:string】
 *【表示条件:visible:boolean】
 *【非活性:disabled:boolean】
 *【クリアボタン:shouldShowClearButton:boolean = true】
 *【2nd入力:showSecondaryInput:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-code-input-search-field',
  templateUrl: './code-input-search-field.html',
  styles: [`
    sg-custom-input {
      width: unset !important;
      margin-right: 5px;
    }
    sg-search-input-field {
      width: unset !important;
    }
  `]
})
export class CodeInputSearchField extends BaseWidget {
  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 内容
   */
  @Input() content:{value: string, value2?: string, label: string}

  /**
   * プレースホルダ
   */
  @Input() placeholder:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * クリアボタン
   */
  @Input() shouldShowClearButton:boolean = true

  /**
   * 2nd入力
   */
  @Input() showSecondaryInput:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  updateValue(value, item) {
    this.content[item] = value
    if (this.content.label) this.content.label = ''
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this.content,
      {id:this.id, type:'change', source:this.content},
      `update by ${this.id}`,
    ))
    this.on("change")
  }
  
  get isInputData() {
    const inputData = {
      label: !this.content || !this.content.value || (this.showSecondaryInput && !this.content.value2) ? '' : this.content.label,
      value: !this.content ? '' : this.content.value,
      value2: !this.content ? '' : this.content.value2
    }
    return inputData;
  }
  
  clear(event) {
    this.store.dispatch(this.actionCreator.resetViewModel(
      this.viewModelPath,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ));
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/code-input-search-field/code-input-search-field.component.ts